import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";

import UIButtonPrimary from "components/UI/Button/Primary";
import { resetWorkItems } from "actions/fetchWorkItemsActions";

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;

  & > * {
    margin: 24px 0;
  }
`;

const WorkListEmpty = ({ onAction }) => {
  return (
    <Wrapper>
      <img src="/assets/images/icon-gallery.png" alt="icon" />
      <h2>Looks like you don't have any work items</h2>
      <UIButtonPrimary onClick={onAction}>Back to all Items</UIButtonPrimary>
    </Wrapper>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    onAction: () => dispatch(resetWorkItems())
  };
};

export default connect(
  null,
  mapDispatchToProps
)(WorkListEmpty);
